import { Fragment, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Stack from 'react-bootstrap/Stack';

import { IoMenu } from "react-icons/io5";
import { useMediaQuery } from 'react-responsive';
import Cookies from 'js-cookie';

import { DeviceSize } from '../configs/Device.js';
import { postData } from '../requests/PostRequests';

import websiteLogoSrc from '../images/Logo-01-Horizontal-350x75.png';

const MenuList = () => {

  async function onSignOut(e) {
    e.preventDefault();
    Cookies.remove('username');
    Cookies.remove('user_id');
    Cookies.remove('token');
    try {
      await postData("/auth/logout", {}, () => {}, () => {});
    } finally {
      window.location.href = "/login";
    }
  }

  return (
    <Fragment>
      <li className="navbar-item navbar-item--1"><a href='/'>Home</a></li>
      <li className="navbar-item navbar-item--2"><a href='/statistics'>Statistics</a></li>
      <li className="navbar-item navbar-item--2"><a href='/edit-courses'>Edit Courses</a></li>
      <li className="navbar-item navbar-item--5"><a href='/edit-resources'>Edit Resources</a></li>
      <li className="navbar-item navbar-item--4"><a href='/edit-team'>Edit Team</a></li>
      <li className="navbar-item navbar-item--7"><a className="btn btn-custom-secondary" href="/" onClick={onSignOut}>Sign Out</a></li>
    </Fragment>
  );
}

const SideMenu = ({ isOpen, onHide }) => {
  return (
    <Offcanvas
      show={isOpen}
      onHide={onHide}
      scroll={true}
      backdrop={true}
      placement={'end'} >
      <Offcanvas.Header closeButton>
        <div className="nav-main-item nav-main-item--1">
          <a href='/'><img className="nav-logo" src={websiteLogoSrc} alt=""></img></a>
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Stack gap={4}>
          <MenuList />
        </Stack>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

const MobileNavLinks = () => {

  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);

  return (
    <div className="nav-main-item nav-main-item--2">
      <nav className="navbar-container">
        {!isSideMenuOpen
          ? <Button variant="light" onClick={() => setIsSideMenuOpen(true)}><IoMenu fontSize={'2em'} /></Button>
          : <></>}
      </nav>
      {isSideMenuOpen
        ? <SideMenu isOpen={isSideMenuOpen} onHide={() => setIsSideMenuOpen(false)} />
        : <></>}
    </div>
  );
}

const WebNavLinks = () => {
  return (
    <div className="nav-main-item nav-main-item--2">
      <nav className="navbar-container">
        <ul className="navbar-list">
          <MenuList />
        </ul>
      </nav>
    </div>
  );
}

const NavBar = () => {
  const isMobile = useMediaQuery({ maxWidth: DeviceSize.laptop });

  return (
    <div className="nav-main-container">
      <div className="nav-main-item nav-main-item--1">
        <a href='/'><img className="nav-logo" src={websiteLogoSrc} alt=""></img></a>
      </div>
      {isMobile
        ? <MobileNavLinks />
        : <WebNavLinks />
      }
    </div>
  );
};

export default NavBar;
